/**
 * Single source for approved client names and URLs.
 * Add directory-only clients with showInPortfolio: false; they need no
 * screenshot or project case study. Existing portfolio consumers use clients.
 */
export const clientDirectory = [
  { name: 'Flag & Anthem', slug: 'flagandanthem', url: 'https://www.flagandanthem.com/' },
  { name: 'Tigmi Trading', slug: 'tigmitrading', url: 'https://tigmitrading.com/' },
  { name: 'Wohven', slug: 'wohven', url: 'https://wohven.com/' },
  { name: 'Vela Scarves', slug: 'velascarves', url: 'https://velascarves.com/' },
  { name: 'Archer Roose', slug: 'archerroose', url: 'https://archerroose.com/' },
  { name: 'Mohala Eyewear', slug: 'mohalaeyewear', url: 'https://mohalaeyewear.com/' },
  { name: 'Standard Procedure', slug: 'standardprocedure', url: 'https://standardprocedure.co/' },
  { name: 'Kentia', slug: 'kentia', url: 'https://kentia.au/' },
  { name: 'Lost & Found', slug: 'shoplostfound', url: 'https://shoplostfound.com/' },
  { name: 'Beachman', slug: 'beachmancr', url: 'https://beachmancr.com/' },
  { name: 'Recoup Wellness', slug: 'recoupwellness', url: 'https://www.recoupwellness.com/' },
  { name: 'Robert W. Stolz', slug: 'robertwstolz', url: 'https://www.robertwstolz.com/' },
  { name: 'Lovevery', slug: 'lovevery', url: 'https://lovevery.com/' },
  { name: 'Equipmaxx', slug: 'equipmaxx', url: 'https://equipmaxx.com/' },
  { name: 'Future Fans', slug: 'futurefans', url: 'https://www.futurefans.com/' },
  { name: 'The Gut Co', slug: 'thegutco', url: 'https://thegutco.com/' },
  { name: 'Epøkhe Eyewear', slug: 'epokhe', url: 'https://www.epokhe.co/' },
  { name: 'Goa Skincare', slug: 'goaskincare', url: 'https://goaskincare.com/' },
  { name: 'Sidekick', slug: 'sidekicktool', url: 'https://sidekicktool.com/' },
];

export const clientScreenshot = (slug) => `/images/portfolio/shopify-${slug}.png`;

// Omitted flags preserve the existing portfolio selection.
export const clients = clientDirectory.filter(client => client.showInPortfolio !== false);
export const getClientDirectory = (locale = 'en') =>
  [...clientDirectory].sort((a, b) => a.name.localeCompare(b.name, locale, { sensitivity: 'base' }));
export const clientHost = (client) => new URL(client.url).hostname.replace(/^www\./, '');
